import React from 'react';
import { useT } from '../../utils/translations';
import { usePublicConfig } from '../../utils/publicConfig';
import Countdown from '../../components/Countdown';
import { YieldChart, Faq } from '../../components/DappWidgets';
import './Landing.css';

const Landing = () => {
  const t = useT();
  const cfg = usePublicConfig();
  const totalStaked = cfg['lp.total_staked'] || '$12.4M';
  const stakers = cfg['lp.stakers'] || '12,846';
  const rewardsPaid = cfg['lp.rewards_paid'] || '$1.9M';

  const go = () => {
    const params = new URLSearchParams(window.location.search);
    const target = params.get('go') || 'app';
    window.location.href = '/' + target;
  };

  return (
    <div className="lp-page">
      {/* 顶部导航 */}
      <header className="lp-header">
        <div className="lp-logo">⬡ osman</div>
        <nav className="lp-nav">
          <a href="#features" onClick={(e) => { e.preventDefault(); document.getElementById('features').scrollIntoView({ behavior: 'smooth' }); }}>{t('lp.nav.features')}</a>
          <a href="#security" onClick={(e) => { e.preventDefault(); document.getElementById('security').scrollIntoView({ behavior: 'smooth' }); }}>{t('lp.nav.security')}</a>
          <a href="#roadmap" onClick={(e) => { e.preventDefault(); document.getElementById('roadmap').scrollIntoView({ behavior: 'smooth' }); }}>{t('lp.nav.roadmap')}</a>
          <a href="#faq" onClick={(e) => { e.preventDefault(); document.getElementById('faq').scrollIntoView({ behavior: 'smooth' }); }}>{t('lp.nav.faq')}</a>
        </nav>
        <button className="lp-cta-sm" onClick={go}>{t('stake.btn')}</button>
      </header>

      {/* Hero */}
      <section className="lp-hero">
        <div className="lp-hero-badge">🔥 {t('stake.limit')}</div>
        <h1>{t('lp.tagline')}</h1>
        <p className="lp-sub">{t('lp.sub')}</p>
        <div className="lp-hero-ctas">
          <button className="lp-cta" onClick={go}>{t('claim.btn')} →</button>
          <button className="lp-cta-ghost" onClick={go}>{t('lp.nav.docs')}</button>
        </div>
        <div className="lp-countdown"><Countdown minutes={30} /></div>
        <div className="lp-hero-chart">
          <YieldChart points={[30, 35, 33, 40, 45, 43, 52, 58, 55, 62, 68, 66, 74, 80]} />
        </div>
      </section>

      {/* 数据统计 */}
      <section className="lp-stats">
        <div className="lp-stat"><b>{totalStaked}</b><span>{t('lp.statStaked')}</span></div>
        <div className="lp-stat"><b>{stakers}</b><span>{t('lp.statStakers')}</span></div>
        <div className="lp-stat"><b>{rewardsPaid}</b><span>{t('lp.statPaid')}</span></div>
        <div className="lp-stat"><b>99.9%</b><span>{t('lp.statUptime')}</span></div>
      </section>

      {/* 特性 */}
      <section className="lp-features" id="features">
        <h2 className="lp-section-title">{t('lp.nav.features')}</h2>
        <div className="lp-feature-grid">
          <div className="lp-feature">
            <div className="lp-f-icon">⚡</div>
            <h3>{t('lp.f1t')}</h3>
            <p>{t('lp.f1d')}</p>
          </div>
          <div className="lp-feature">
            <div className="lp-f-icon">🔒</div>
            <h3>{t('lp.f2t')}</h3>
            <p>{t('lp.f2d')}</p>
          </div>
          <div className="lp-feature">
            <div className="lp-f-icon">💎</div>
            <h3>{t('lp.f3t')}</h3>
            <p>{t('lp.f3d')}</p>
          </div>
          <div className="lp-feature">
            <div className="lp-f-icon">🚀</div>
            <h3>{t('lp.f4t')}</h3>
            <p>{t('lp.f4d')}</p>
          </div>
          <div className="lp-feature">
            <div className="lp-f-icon">🛡️</div>
            <h3>{t('lp.f5t')}</h3>
            <p>{t('lp.f5d')}</p>
          </div>
          <div className="lp-feature">
            <div className="lp-f-icon">🌍</div>
            <h3>{t('lp.f6t')}</h3>
            <p>{t('lp.f6d')}</p>
          </div>
        </div>
      </section>

      {/* 安全/审计 */}
      <section className="lp-security" id="security">
        <h2 className="lp-section-title">{t('lp.nav.security')}</h2>
        <div className="lp-audit-row">
          <div className="lp-audit-card">
            <div className="lp-audit-logo">🛡️ CertiK</div>
            <p>{t('lp.auditText')}</p>
          </div>
          <div className="lp-audit-card">
            <div className="lp-audit-logo">🔍 Trail of Bits</div>
            <p>{t('lp.auditText')}</p>
          </div>
          <div className="lp-audit-card">
            <div className="lp-audit-logo">⛓️ ChainSecurity</div>
            <p>{t('lp.auditText')}</p>
          </div>
        </div>
      </section>

      {/* 路线图 */}
      <section className="lp-roadmap" id="roadmap">
        <h2 className="lp-section-title">{t('lp.nav.roadmap')}</h2>
        <div className="lp-road-list">
          <div className="lp-road-item done"><span className="lp-road-dot">✓</span><b>Q1 2026</b><p>{t('lp.road1')}</p></div>
          <div className="lp-road-item done"><span className="lp-road-dot">✓</span><b>Q2 2026</b><p>{t('lp.road2')}</p></div>
          <div className="lp-road-item"><span className="lp-road-dot">●</span><b>Q3 2026</b><p>{t('lp.road3')}</p></div>
          <div className="lp-road-item"><span className="lp-road-dot">○</span><b>Q4 2026</b><p>{t('lp.road4')}</p></div>
        </div>
      </section>

      {/* FAQ */}
      <section className="lp-faq" id="faq">
        <h2 className="lp-section-title">{t('lp.nav.faq')}</h2>
        <Faq items={[
          { q: t('stake.faq1q'), a: t('stake.faq1a') },
          { q: t('stake.faq2q'), a: t('stake.faq2a') },
          { q: t('stake.faq3q'), a: t('stake.faq3a') },
        ]} />
      </section>

      {/* 底部 CTA */}
      <section className="lp-final">
        <h2>{t('lp.finalTitle')}</h2>
        <button className="lp-cta" onClick={go}>{t('stake.btn')} →</button>
      </section>

      {/* 页脚 */}
      <footer className="lp-footer">
        <p>{t('lp.footer')}</p>
        <p className="lp-legal">
          {t('lp.legal')} <a href="#">{t('lp.terms')}</a> / <a href="#">{t('lp.privacy')}</a>.
        </p>
      </footer>
    </div>
  );
};

export default Landing;
